module.exports = __webpack_public_path__ + "img/VideoPromo.768f12cd.svg";